module.exports = __webpack_public_path__ + "270c4d1ad6e342be8b1153fc270894b9.pdf";